import { styled } from '@mui/material';

import { generateClasses } from '../../../../utils/helper';
import ClassWidget from '../../../class/ClassWidget';
import { WidgetWrapperRadioOption } from '../../styles';

export const classListClasses = generateClasses('ClassList', ['classCard', 'selectedClass']);

export const RadioOption = styled(WidgetWrapperRadioOption)(() => ({
  [`& .${classListClasses.classCard}`]: {
    // flex property should work here because RadioOption is a flex container
    flex: 1,
  },
}));

export const ClassCard = styled(ClassWidget)(({ theme }) => ({
  [`&.${classListClasses.selectedClass}`]: {
    borderColor: 'transparent',
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}));
